import React, { createContext, useContext } from "react";
import { OrderCheckoutResumeDTO } from "../types/checkout.types";

export type CheckoutResumeContextValue = {
  resume: OrderCheckoutResumeDTO;
  orderGuid: string;
  resumeToken: string;
};

export const CheckoutResumeContext = createContext<CheckoutResumeContextValue | null>(null);

export const CheckoutResumeProvider: React.FC<{
  resume: OrderCheckoutResumeDTO;
  orderGuid: string;
  resumeToken: string;
  children: React.ReactNode;
}> = ({ resume, orderGuid, resumeToken, children }) => {
  return (
    <CheckoutResumeContext.Provider value={{ resume, orderGuid, resumeToken }}>
      {children}
    </CheckoutResumeContext.Provider>
  );
};

export const useCheckoutResume = () => {
  const ctx = useContext(CheckoutResumeContext);
  if (!ctx) {
    throw new Error("useCheckoutResume must be used within CheckoutResumeProvider");
  }
  return ctx;
};

